import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Router from './Router';
import ScrollToTop from './components/common/ScrollToTop';
import ErrorBoundary from './components/common/ErrorBoundary';
import ScrollToTopButton from './components/ui/ScrollToTop';
import CookieConsentBanner from './components/common/CookieConsentBanner';
// import ChatWidget from './components/chat/ChatWidget'; // Temporarily disabled for first release
import { ScrollProvider, useScrollContext } from './contexts/ScrollContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { AuthProvider } from './contexts/AuthContext';

function AppContent() {
  const location = useLocation();
  const { setIsHomePage } = useScrollContext();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    setIsHomePage(isHomePage);
  }, [isHomePage, setIsHomePage]);

  return (
    <ErrorBoundary>
      <Box minH="100vh" display="flex" flexDirection="column">
        <ScrollToTop />
        <Header />
        <Box 
          as="main" 
          flex="1" 
          pt={isHomePage ? 0 : { base: '60px', md: '65px' }}
        >
          <ErrorBoundary>
            <Router />
          </ErrorBoundary>
        </Box>
        {/* Footer - always visible and positioned normally */}
        <Footer />
        <ScrollToTopButton />
        <CookieConsentBanner />
        {/* <ChatWidget /> */} {/* Temporarily disabled for first release */}
      </Box>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <HelmetProvider>
      <TranslationProvider>
        <AuthProvider>
          <ScrollProvider>
            <AppContent />
          </ScrollProvider>
        </AuthProvider>
      </TranslationProvider>
    </HelmetProvider>
  );
}

export default App;
